import React from 'react'
import clsx from 'clsx'
import { Callout } from '@sylveraio/design-system'

export function columnise(
  key: string,
  first: JSX.Element,
  last: JSX.Element,
  singleColumn?: boolean,
  callout?: {
    text?: string
    description?: string | React.ReactElement
  },
): JSX.Element {
  return (
    <section
      key={key}
      className={clsx('py-6 first:pt-0 last:pb-0', {
        'grid grid-cols-12 gap-4 ': !singleColumn,
        'flex flex-col space-y-4': singleColumn,
      })}
    >
      <span className="col-span-4">{first}</span>
      <span className="col-span-8 flex flex-col space-y-6">
        {last}
        {callout && (
          <Callout
            variant="info"
            text={callout.text}
            description={callout.description}
            showIcon
          />
        )}
      </span>
    </section>
  )
}
